import { useState, useEffect } from 'react';
import { fetchEvaluationQuestions } from 'Api/editCourseLessons';

const useQuestions = ({ lessonId }) => {
  const [questions, setQuestions] = useState();

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchEvaluationQuestions({ lessonId }).then(questionPayload => {
        if (questionPayload.length > 0) {
          setQuestions(questionPayload);
        } else {
          setQuestions(false);
        }
      });
    }

    return () => {
      isMounted = false;
      setQuestions([]);
    };
  }, [lessonId]);

  return {
    questions,
  };
};

export default useQuestions;
